import howToCleanHand from 'assets/images/elearning/hand-care/how-to-clean-hand-2026.png';
import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { Box } from 'components/universal/box';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { useTopic } from 'hooks/useTopic';
import { useTranslation } from 'react-i18next';

export const ProperHandWashing = () => {
    const { t } = useTranslation('', {
        keyPrefix:
            'elearning.handHygiene.handDisinfectionAndWashing.properHandWashing',
    });
    const { tasks, correctAnswer, isAnswerChecked } = useTopic();

    if (tasks[0]?.id === 34) {
        tasks[0]['title'] = t('tastTitle');
        tasks[0]['description'] = t('tastDescription');
    }

    return (
        <div className="container">
            <Heading className="mb-5" headingLevel="h1" headingStyle="h2a">
                {t('title1')}
            </Heading>

            <Box className="boxQuestion boxQuestion-with-padding">
                <Paragraph fontWeight={700}>{t('title3')}</Paragraph>
                <div className="space24"></div>
                <img src={howToCleanHand} alt="how-to-clean-hand" />
            </Box>

            <TasksGenerator
                tasks={tasks}
                isChecked={isAnswerChecked}
                correctAnswer={correctAnswer}
                isQuiz={false}
            />
        </div>
    );
};
